// extracted by mini-css-extract-plugin
module.exports = {"root":"pagination_root__2Vu9v","pgn_cnt":"pagination_pgn_cnt__1h9aJ","pgn_arrows":"pagination_pgn_arrows__-ieUx"};